import { render, staticRenderFns } from "./DynamicPopup.vue?vue&type=template&id=079e95f4&scoped=true"
import script from "./DynamicPopup.vue?vue&type=script&lang=js"
export * from "./DynamicPopup.vue?vue&type=script&lang=js"
import style0 from "./DynamicPopup.vue?vue&type=style&index=0&id=079e95f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e95f4",
  null
  
)

export default component.exports